import { ProjectPlan } from "./Project";

export class ArtWork {
  constructor(readonly title: string, readonly projectPlan: ProjectPlan) {}
}
